import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSocket } from "../context/SocketContext";

const TestSocket = () => {
  const { id } = useParams();
  const orderId = Number(id);

  const { socket, isConnected } = useSocket();
  const [log, setLog] = useState([]);
  const [userId] = useState(12);
  const [userName] = useState("Adrián");

  const appendLog = (message) => {
    setLog((prev) => [...prev, message]);
  };

  useEffect(() => {
    if (!socket) return;

    // Escucha errores generales
    socket.on("error", (data) => {
      appendLog(`Error: ${data.message}`);
    });

    // Escucha si la orden fue liberada
    socket.on("order-released", ({ orderId }) => {
      appendLog(`Orden liberada: ${orderId}`);
    });

    // Escucha si la orden fue bloqueada correctamente
    socket.on("order-locked", ({ orderId }) => {
      appendLog(`Orden bloqueada exitosamente: ${orderId}`);
    });

    // Escucha si hubo un error al intentar bloquearla
    socket.on("order-lock-failed", ({ message }) => {
      appendLog(`No se pudo bloquear la orden: ${message}`);
    });

    return () => {
      socket.off("error");
      socket.off("order-released");
      socket.off("order-locked");
      socket.off("order-lock-failed");
    };
  }, [socket]);

  useEffect(() => {
    if (socket && isConnected) {
      handleLockOrder(); // Se ejecuta automáticamente al cargar
    }
  }, [socket, isConnected]);

  // Libera la orden automáticamente al desmontar el componente (navegación, redirección, etc.)
  useEffect(() => {
    return () => {
      if (socket && isConnected) {
        socket.emit("disconnect-order", { orderId });
        console.log(`Orden ${orderId} liberada automáticamente al salir.`);
      }
    };
  }, [socket, isConnected, orderId]);

  const handleLockOrder = () => {
    socket.emit("read-order", { orderId, userId, userName });
    appendLog(`Intentando bloquear orden: ${orderId}`);
  };

  const handleUnlockOrder = () => {
    socket.emit("disconnect-order", { orderId });
    appendLog(`Desbloqueando orden: ${orderId}`);
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Prueba de Socket.IO</h2>
      <p>Estado de conexión: {isConnected ? "Conectado" : "Conectando..."}</p>

      <button onClick={handleLockOrder} disabled={!isConnected}>
        Bloquear orden
      </button>
      <button onClick={handleUnlockOrder} disabled={!isConnected}>
        Desbloquear orden
      </button>

      <h3>Logs:</h3>
      <ul>
        {log.map((item, index) => (
          <li key={index} style={{ fontFamily: "monospace" }}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default TestSocket;
